import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";

@Injectable({ providedIn: 'root' })
export class TooltipService {
  private _enabled = new BehaviorSubject<boolean>(true);

  get enabled$(): Observable<boolean> {
    return this._enabled.asObservable();
  }

  setEnabled(enabled: boolean) {
    this._enabled.next(enabled);
  }

  getCurrentValue(): boolean {
    return this._enabled.getValue();
  }
}
